import { AspectRatio } from "../components/common/DropDowns/StaticDropdown";
import { TgTrainingVersion } from "../pages/NewTG/Models/store/tg-model-store";

export type TextToImageConfigType = {
	model: string;
	model_version: string;
	aspect_ratio: AspectRatio;
	medium: string;
	negative_prompt?: string;
	prompt_enhancement?: boolean;
	num_results?: number;
	steps_num?: number;
	displaySeed?: boolean;
	seed?: number;
	prompt?: string;
	sync?: boolean;
	fast?: boolean;
	model_id?: string | string[] | undefined;
	tailored_model_id?: string | string[] | undefined;
	tailored_model_influence?: number;
	format?: "png" | "svg";
	model_name?: string;
	image_reference?: ImageReferenceConfigsType;
	training_version?: TgTrainingVersion;
	generation_prefix?: string;
	include_generation_prefix?: boolean;
	restyle_portrait?: boolean;
	enhance_image?: boolean;
	content_moderation?: boolean;
	ui_type?: string;
};

export type ImageReferenceConfigsType = {
	structure_ref_influence?: number;
};

export type GalleryItemProps = {
	title: string;
	description?: string;
	images: { url: string; prompt: string; influence: number }[];
	onClose?: () => void;
	activeTab: string;
};

export type SyntheticEventProps = {
	target: {
		files: FileList | null;
		value: string;
	};
};

export enum modelTypes {
	Base = "base",
	Fast = "fast",
	Hd = "hd",
	Tailored = "tailored",
}
